import { Modal as AntdModal } from 'antd'
import React from 'react'
import styled from 'styled-components'

interface ModalProps {
  children: React.ReactNode
  isOpen: boolean
  onClose: ((e: React.MouseEvent<HTMLElement, MouseEvent>) => void) | undefined
  modalWidth?: number
  title?: string
}

export const Modal = ({ children, isOpen, onClose, modalWidth, title }: ModalProps) => {
  return (
    <S.ModalWrapper title={title} visible={isOpen} footer={null} onCancel={onClose} centered closable={false} width={modalWidth}>
      {children}
    </S.ModalWrapper>
  )
}

export const S = {
  ModalWrapper: styled(AntdModal)`
    .ant-modal-body {
      background-color: ${props => props.theme.colors.gray[0]};
    }
  `
}
